import { ROUTE_NAMES_DASHBOARD_VIEW } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const dashboardViewRoute: InvariantRoute = {
	name: ROUTE_NAMES_DASHBOARD_VIEW,
	path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
	query: ['maximized?'],
	exact: true,
};
